import { render } from "./CrudVeiculoTrator.vue?vue&type=template&id=341d7b99"
import script from "./CrudVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CrudVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script